
const getTrackingType = (data) => {
  const { type } = data;
  switch (type) {
  case 'quiz':
    return 'knowledge-quiz';
  case 'poll':
    return `${ type }:${ (data.questionType || 'list') }`;
  case 'imageslideshow':
    const trackingPrefix = (() => {
      const hasHotspots = data.slides.some(slide => slide.hotSpots?.length);
      return hasHotspots ? 'hasHotspots' : 'noHotspots';
    })();

    return `${ type }:${ trackingPrefix }`;
  case 'toplist' :
    return 'toplist-vote';
  default:
    return type;
  }
};

const generateTrackingValue = (data, eventText, options = {}) => {
  const {
    delimiter = '|',
    eventTextPrefix = false,
    // namespaceSuffix = false
  } = options;

  const namespace = 'editorial-tools';
  const type = getTrackingType(data).toLowerCase();

  const defaultPrefix = `${ type }${ delimiter }${ data.id }`;

  if (eventText) {
    if (eventTextPrefix) {
      return `${ eventText }${ delimiter }${ defaultPrefix }${ delimiter }${ namespace }`;
    } else {
      return `${ namespace }${ delimiter }${ defaultPrefix }${ delimiter }${ eventText }`;
    }
  }

  return `${ namespace }${ delimiter }${ defaultPrefix }`;
};

export default generateTrackingValue;


